var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "table",
      {
        staticClass: "table table-striped table-bordered w-100",
        style: "font-size: " + this.dtFontSize + "px;",
        attrs: { id: _vm.id },
      },
      [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.columnas, function (columna, k) {
              return _c("th", { key: k }, [
                _c("i", { class: columna.clase }),
                _vm._v(" " + _vm._s(columna.nombre) + "\n        "),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.datos, function (columna, k) {
            return _c(
              "tr",
              { key: k },
              [
                _vm._l(columna, function (dato, j) {
                  return _c("td", { key: j }, [
                    _c("span", [_vm._v(_vm._s(dato))]),
                  ])
                }),
                _vm._v(" "),
                _vm.columnDetalles
                  ? _vm._t(
                      "default",
                      function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("test", columna[0])
                                },
                              },
                            },
                            [_vm._v("Ver")]
                          ),
                        ]
                      },
                      { button: columna }
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }